import React from 'react';
import { connect } from 'react-redux';
import { injectIntl, FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { PropTypes } from 'prop-types';
import treeChanges from 'tree-changes';

import { Card, Tabs, Tooltip, Spin } from 'antd';

import CountAdjReasonProcessActions from '../../Stores/CountAdjReasonProcess/Actions';

import CountAdjReasonList01Table from '../CountAdjReasonList01/CountAdjReasonList01Table';

const { TabPane } = Tabs;

class CountAdjReasonProcessScreen extends React.PureComponent {
  componentDidMount() {
    const { curSiteFlowId, fetchCountAdjReasonProcess } = this.props;
    if (curSiteFlowId > 0) {
      fetchCountAdjReasonProcess();
    }
  }

  componentDidUpdate(prevProps) {
    const { curSiteFlowId, fetchCountAdjReasonProcess } = this.props;

    const { changed } = treeChanges(prevProps, this.props);

    if (changed('curSiteFlowId')) {
      if (curSiteFlowId > 0) {
        fetchCountAdjReasonProcess();
      }
    }
  }

  componentWillUnmount() {}

  render() {
    const { intl, match, process, appPath, processIsLoading } = this.props;

    return (
      <Card>
        <Spin spinning={processIsLoading}>
          <Tabs type="card" activeKey={match.params.proc_type}>
            {process.map(value => (
              <TabPane
                tab={
                  // eslint-disable-next-line react/jsx-wrap-multilines
                  <Tooltip
                    placement="bottom"
                    title={intl.formatMessage({ id: `${value.proc_type.toLowerCase()}_desc` })}
                  >
                    <Link
                      style={value.proc_type !== match.params.proc_type ? { color: 'black' } : {}}
                      to={`${appPath}/countAdjReasonProcess/index/${value.proc_type}`}
                    >
                      <FormattedMessage id={`${value.proc_type.toLowerCase()}_label`} />
                    </Link>
                  </Tooltip>
                }
                key={value.proc_type}
              />
            ))}
          </Tabs>
        </Spin>

        {match.params.proc_type === 'COUNT_ADJ_REASON_LIST_01' && (
          <CountAdjReasonList01Table match={match} />
        )}
      </Card>
    );
  }
}

CountAdjReasonProcessScreen.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  intl: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  match: PropTypes.object,
  appPath: PropTypes.string,
  process: PropTypes.arrayOf(PropTypes.object),
  processIsLoading: PropTypes.bool,

  curSiteFlowId: PropTypes.number,
  fetchCountAdjReasonProcess: PropTypes.func
};

CountAdjReasonProcessScreen.defaultProps = {
  intl: {},
  match: {},
  appPath: '',
  process: [],
  processIsLoading: false,

  curSiteFlowId: 0,
  fetchCountAdjReasonProcess() {}
};

const mapStateToProps = state => ({
  appPath: state.app.appPath,
  process: state.countAdjReasonProcess.process,
  processIsLoading: state.countAdjReasonProcess.processIsLoading,

  curSiteFlowId: state.app.curSiteFlowId
});

const mapDispatchToProps = dispatch => ({
  fetchCountAdjReasonProcess: () =>
    dispatch(CountAdjReasonProcessActions.countAdjReasonProcessFetchCountAdjReasonProcess())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(CountAdjReasonProcessScreen));
